import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export const NO_ACCESS_TOKEN_MESSAGE =
  'No access token found or failed to refresh';

export class NoAccessTokenError extends EluveError {
  static override readonly errorName = 'NoAccessTokenError';
  readonly logLevel: LogLevel = 'info';

  constructor(message = NO_ACCESS_TOKEN_MESSAGE, args?: EluveErrorArgs) {
    super(message, args);
  }
}
